var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarHorsePower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.007 512.007",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.642,
    y: -17.618,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 34.0111 314.0125)",
    width: 60.821,
    height: 267.139
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.801,66.312l-87.214,87.214l62.758,62.758L66.977,381.65c-17.291-0.466-34.733,5.866-47.9,19.032 c-25.432,25.433-25.432,66.816,0,92.25c12.718,12.717,29.421,19.074,46.126,19.074c16.703,0,33.408-6.358,46.125-19.074 c13.167-13.167,19.498-30.609,19.032-47.9l165.367-165.367l62.758,62.758l87.214-87.214L256.801,66.312z M88.029,469.634 c-12.586,12.587-33.066,12.587-45.654,0c-12.586-12.586-12.586-33.067,0-45.654c6.294-6.294,14.559-9.44,22.827-9.44 c8.265,0,16.533,3.148,22.826,9.44C100.615,436.567,100.615,457.048,88.029,469.634z M322.76,213.362 c-6.658,6.658-17.454,6.658-24.111,0c-6.658-6.658-6.658-17.454,0-24.112c6.658-6.658,17.454-6.658,24.111,0 C329.418,195.908,329.418,206.703,322.76,213.362z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarHorsePower);
export default __webpack_public_path__ + "static/media/car_horsePower.ef6420308149f2874dc89d8c22373e6a.svg";
export { ForwardRef as ReactComponent };